import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ExtendedWarrantyOptions from "./sections/ExtendedWarrantyOptions";
import OurInsectControlServices from "./sections/OurInsectControlServices";
import RequestAQuote from "./sections/RequestAQuote";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ExtendedWarrantyOptions />
      <OurInsectControlServices />
      <RequestAQuote />
      <Footer />
    </div>;
}